module.exports = "<div class=component-hide-content-one> <span>{{tableName}}</span> <span class=show-type-button>显示</span> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/left-content/leftContent.hideContent/leftContent.hideContent.html
// module id = 4887
// module chunks = 50